module.exports = __webpack_public_path__ + "static/media/sample_image_three.618d9e6c.png";